import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpService} from '../../../core';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  isSuccess: boolean;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private httpService: HttpService) {
    this.isSuccess = undefined;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const source = params.source;
      const key = params.key;
      const fd = new FormData();
      fd.append('userEmail', source);
      fd.append('decode', key);
      fd.append('terminal_type', 'DEVELOPER');
      this.httpService.emailVerification(fd)
        .subscribe(res => this.handelResponse(res));
    });
  }

  handelResponse(res: any) {
    this.isSuccess = res.code === 1;
    console.log('----res----', this.isSuccess);
  }

  login() {
    this.router.navigate(['/auth/login']);
  }
}
